<template> 
  <div>
    <div class="content flex-row-fluid mt-2" id="kt_content">
        <!-- <StatsBar></StatsBar> -->
        <div class="card" v-if="!isViewDetail">
            <div class="card-body pt-0">
                <div class="row px-0">
                    <div class="col-lg-9">
                        <form class="form fv-plugins-bootstrap5 fv-plugins-framework p-3 pb-0 pt-1 rounded-2">
                            <div class="fv-row mb-7 row">
                                <div class="col-lg-3">
                                    <label class="fs-6 fw-bold form-label mt-3">
                                        <span>{{ $t('start_date') }}</span>
                                    </label>
                                    <Datepicker :locale="$datepickerLocale()"  textInput :textInputOptions="{ format: 'dd.MM.yyyy' }" v-maska="'##.##.####'" v-model="form.first_date" inputClassName="form-control" format="dd.MM.yyyy" autoApply :clearable="false" weekNumbers @update:modelValue="getData(true)" :monthChangeOnScroll="'inverse'" :enableTimePicker="false"></Datepicker>  
                                </div>
                                <div class="col-lg-3">
                                    <label class="fs-6 fw-bold form-label mt-3">
                                        <span>{{ $t('end_date') }}</span>
                                    </label>
                                    <Datepicker :locale="$datepickerLocale()"  textInput :textInputOptions="{ format: 'dd.MM.yyyy' }" v-maska="'##.##.####'" v-model="form.last_date" inputClassName="form-control" format="dd.MM.yyyy" autoApply :clearable="false" weekNumbers @update:modelValue="getData(true)" :monthChangeOnScroll="'inverse'" :enableTimePicker="false"></Datepicker>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div class="col-lg-3" v-if="this.$isCredentialActive(23,'R')">
                        <div class="d-flex justify-content-end mt-8" data-kt-customer-table-toolbar="base">
                            <Popper hover placement="top">
                                <button type="button" class="btn btn-light border border-gray-300 btn-icon me-3" @click="this.setCriteriasToDefault()">
                                    <i class="bi bi-eraser-fill fs-4"> </i>
                                </button>
                                <template #content>
                                    <span class="text-gray-800"> {{ $t('reset_all_criterias') }} </span>
                                </template>
                            </Popper>
                            <button v-if="this.$getUser().is_allow_list_all_data" type="button" class="btn btn-light-primary border border-primary" @click="getData(false)"  data-kt-indicator="on">
                                <span class="svg-icon svg-icon-muted"><svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect y="6" width="16" height="3" rx="1.5" fill="currentColor"/>
                                <rect opacity="0.3" y="12" width="8" height="3" rx="1.5" fill="currentColor"/>
                                <rect opacity="0.3" width="12" height="3" rx="1.5" fill="currentColor"/>
                                </svg>
                                </span>
                                <span v-if="!this.isListProgressing"> {{ $t('list_transactions') }} </span> 
                                <span class="indicator-progress" v-if="this.isListProgressing">
                                    {{ $t('getting_data') }} <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
                                </span> 
                            </button>
                        </div>
                    </div>
                </div>
                <div class="separator my-5 mt-0 border-gray-300" style="margin-top: -10px !important;"></div>
                <div class="table-responsive">
                    <!-- <ListOptions :name="this.$options.name" ref="listOptionComponent"></ListOptions> -->
                    <DxDataGrid id="gridContainer" :key="$i18n.locale" :show-borders="true" 
                        key-expr="id" 
                        :data-source="transactionsList" 
                        :allow-column-reordering="true"  
                        :allow-column-resizing="true" 
                        :column-auto-width="true" 
                        :row-alternatin-enabled="true"
                        :hover-state-enabled="true" 
                        :show-row-lines="true" 
                        :ref="'dataGrid'"
                        :scrolling="{ mode: 'virtual' }"
                        @exporting="this.$onExporting($event , 'Expense-Transaction-List')"> 
                        
                        <DxFilterRow :visible="true"/>
                        <DxHeaderFilter :visible="true"/>
                        <DxGroupPanel :visible="false"/>      
                        <DxExport :enabled="false" :formats="['xlsx', 'pdf']" :allow-export-selected-data="false"/>
                        <DxPaging :page-size="10"/>
                        <DxPager :visible="false" :allowed-page-sizes="pageSizes" :show-page-size-selector="showPageSizeSelector" :show-info="true" :show-navigation-buttons="true"/>
                        <DxSearchPanel :visible="false"/>

                        <DxColumn data-field="detail" caption="..." cell-template="detail-cell-template" alignment="center" :allow-exporting="false" :width="45"/>
                        <DxColumn data-field="record_date" :caption="$t('record_date')" data-type="date" format="dd.MM.yyyy" alignment="right" header-cell-template="record-date-header" :width="120" cell-template="record_date-cell-template"/>
                        <DxColumn data-field="docket_number" :caption="$t('docket_number')" header-cell-template="docket-number-header" cell-template="docket_number-cell-template"/> 
                        <DxColumn data-field="docket_type_name" :caption="$t('type')" cell-template="docket_type_name-cell-template"/> 
                        <DxColumn data-field="created_by" :caption="$t('created_by')" cell-template="created-by-cell-template"/>

                        <template #docket-number-header>
                            <div>{{ $t('docket_number') }}</div>
                        </template>
                        <template #record-date-header>
                            <div>{{ $t('record_date') }}</div>
                        </template>

                        <!-- Cell Templates -->
                        <template #detail-cell-template="{ data }">
                            <a href="#" class="btn btn-sm btn-icon text-hover-primary w-20px h-20px" @click="onOpenDetail(data.data)">
                                <i class="fa fa-eye text-gray-600 fs-3"></i>
                            </a>
                        </template>
                        <template #record_date-cell-template="{ data }">
                                <a href="#" class="text-gray-800 text-hover-primary" @click="updateDocket(data.data.id)">
                                <div>
                                    <span class="text-gray-900"> 
                                        {{ previewDate(data.data.record_date) }}
                                    </span> 
                                </div>
                            </a>
                        </template>
                        <template #docket_number-cell-template="{ data }">
                            <span class="badge badge-circle text-hover-primary badge-light me-3" @click="updateDocket(data.data.id)">
                                <i class="bi bi-pencil text-gray-900"></i> 
                            </span>
                            <a href="#" class="text-gray-800 text-hover-primary" @click="updateDocket(data.data.id)">
                                {{ data.data.docket_number }}
                            </a>
                        </template>
                        <template #docket_type_name-cell-template="{ data }">
                            <a href="#" class="text-gray-800 text-hover-primary" @click="updateDocket(data.data.id)">
                                {{ data.data.docket_type_name }}
                            </a>
                        </template>
                        <template #created-by-cell-template="{ data }">
                                <a href="#" class="text-gray-800 text-hover-primary" @click="updateDocket(data.data.id)">
                                    {{ data.data.created_by }}
                                </a>
                        </template> 
                        <DxSummary>
                            <DxTotalItem column="id" summary-type="count" :display-format="`${$t('record')}: {0}`" show-in-column="record_date"/> 
                        </DxSummary>

                        <DxStateStoring
                            :enabled="true"
                            type="custom"
                            :storage-key="this.storageKey"
                            :ref="dataGrid" 
                            :saving-timeout="1000"
                            :custom-load="LoadDXState"
                        />
                    </DxDataGrid>
                </div>                
            </div>
        </div> 

        <!-- Transaction Items List -->
        <div class="card bg-light border-gray-300 h-xl-100" v-if="isViewDetail">
            <div class="card-header">
                <div class="card-title">
                    {{ $t('transaction_detail') }}
                    <div class="d-flex d-grid gap-5 ms-5">
                        <div class="d-flex flex-column flex-shrink-0">
                            <span class="d-flex align-items-center fs-7 fw-bold text-gray-500">
                                <i class="bi bi-calendar-check me-2"></i> {{previewDate(transactionDetailData.record_date)}}
                            </span>
                        </div>
                        <div class="d-flex flex-column flex-shrink-0">
                            <span class="d-flex align-items-center fs-7 fw-bold text-gray-500">
                                <i class="bi bi-receipt me-2"></i> {{transactionDetailData.docket_number}}
                            </span>
                        </div>
                    </div>
                </div>
                <div class="card-toolbar">
                    <button type="button" class="btn btn-light btn-lg border border-gray-300" @click="onBackStep()">
                        <i class="bi bi-chevron-left"></i>
                        <span class="indicator-label">{{ $t('back') }}</span> 
                    </button>
                </div>
            </div>
            <div class="card-body" v-if="transactionDetailList.length > 0">         
                <div class="table-responsive">                    
                    <DxDataGrid id="gridContainer" :key="$i18n.locale" 
                        :show-borders="true" 
                        key-expr="id" 
                        :data-source="transactionDetailList" 
                        :allow-column-reordering="true"  
                        :allow-column-resizing="true" 
                        :column-auto-width="true" 
                        :row-alternatin-enabled="true"
                        :hover-state-enabled="true" 
                        :show-row-lines="true"
                        :customize-columns="onCustomizeColumn"
                        @exporting="this.$onExporting($event , 'Expense-transaction-items')"
                        :scrolling="{ mode: 'virtual' }"
                        @option-changed="handlePropertyChange"> 

                        <DxFilterRow :visible="true"/>
                        <DxHeaderFilter :visible="true"/>
                        <DxGroupPanel :visible="true"/>      
                        <DxExport :enabled="this.$getUser().is_allow_export" :formats="['xlsx','pdf']" :allow-export-selected-data="false"/>
                        <DxPaging :page-size="pageSize"/>
                        <DxPager :visible="false" :allowed-page-sizes="pageSizes" :show-page-size-selector="showPageSizeSelector" :show-info="true" :show-navigation-buttons="true"/> 
                        <DxSearchPanel :visible="true"/> 
                        <DxColumn data-field="id" caption="" alignment="right" cell-template="id-cell-template" :allow-exporting="false"/> 
                        <DxColumn data-field="transaction_date" :caption="$t('date')" data-type="date" alignment="right" format="dd.MM.yyyy" cell-template="transaction_date-cell-template"/>   
                        <DxColumn data-field="cash_bank_account_name" :caption="$t('expense_account')" header-cell-template="expense-account-header" cell-template="cash_bank_account_name-cell-template"/>   
                        <DxColumn data-field="payment_account_name" :caption="$t('payment_account')" header-cell-template="payment-account-header" cell-template="payment_account_name-cell-template"/>   
                        <DxColumn data-field="transaction_number" :caption="$t('transaction_no')" header-cell-template="transaction-no-header" cell-template="transaction_number-cell-template"/>  
                        <DxColumn data-field="amount" :sorting-method="this.$numericSort" :caption="$t('amount')" alignment="right" cell-template="amount-cell-template"/>
                        <DxColumn data-field="currency" :caption="$t('currency')" cell-template="currency-cell-template"/>  
                        <DxColumn data-field="rate" :caption="$t('rate')" :sorting-method="this.$numericSort" alignment="right" cell-template="rate-cell-template"/> 
                        <DxColumn data-field="amount_local" :sorting-method="this.$numericSort" :caption="$t('local_amount')" alignment="right" header-cell-template="local-amount-header" cell-template="amount_local-cell-template"/> 
                        <DxColumn data-field="payment_status_name" :caption="$t('payment_status')" alignment="left" cell-template="payment_status-cell-template"/> 
                        <DxColumn data-field="description" :caption="$t('description')" cell-template="description-cell-template"/> 


                        <!-- Yerel para birimi gösterimi için özel sütun şablonu oluşturulur --> 
                        <template #headerLocalTemplate="{ data: data }">
                            <div v-html="setColumnTemplateForLocal(data)"></div> 
                        </template>
                        
                        <template #transaction-date-header>
                            <div>{{ $t('transaction_date') }}</div>
                        </template>
                        <template #payment-account-header>
                            <div>{{ $t('payment_account') }}</div>
                        </template>
                        <template #expense-account-header>
                            <div>{{ $t('expense_account') }}</div>
                        </template>
                        <template #transaction-no-header>
                            <div>{{ $t('transaction_no') }}</div>
                        </template>
                        <template #gross-amount-header>
                            <div>{{ $t('gross_amount') }}</div>
                        </template>
                        <template #gross-local-amount-header>
                            <div>{{ $t('gross_local_amount') }}</div>
                        </template>

                        <template #id-cell-template="{ data }">
                            <a href="#" class="text-gray-800 text-hover-primary">
                                {{ getRowNumber(data) }}
                            </a>
                        </template>
                        <template #transaction_date-cell-template="{ data }">
                                <span class="text-gray-800 p-3 align-middle text-end" > {{ previewDate(data.data.transaction_date) }}</span>
                        </template>
                        <template #cash_bank_account_name-cell-template="{ data }">
                                <span class="text-gray-800 fw-bold p-3 align-middle" > {{ data.data.cash_bank_account_name }}</span>
                        </template>
                        <template #payment_account_name-cell-template="{ data }">
                                <span class="text-gray-800 fw-bold p-3 align-middle" > {{ data.data.payment_account_name }}</span>
                        </template>
                        <template #transaction_number-cell-template="{ data }">
                            <span class="text-gray-800 p-3 align-middle" >{{ data.data.transaction_number }}</span>
                        </template>
                        <template #amount-cell-template="{ data }">
                                <span class="text-gray-800 text-end p-3 align-middle"> {{data.data.amount}}</span>
                        </template>
                        <template #currency-cell-template="{ data }">
                                <span class="text-gray-800 p-3 align-middle"> {{data.data.currency}}</span>
                        </template>
                        <template #rate-cell-template="{ data }">
                                <span class="text-gray-800 text-end p-3 align-middle"> {{data.data.rate}} </span>
                        </template>
                        <template #amount_local-cell-template="{ data }">
                                <span class="text-gray-800 text-end p-3 align-middle"> {{data.data.amount_local}} </span>
                        </template>
                        <template #payment_status-cell-template="{ data }">
                            <span class="text-gray-800 p-3 align-middle"> {{ data.data.payment_status_name }} </span>
                        </template>
                        <template #description-cell-template="{ data }">
                                <span class="text-gray-800 text-end p-3 align-middle"> {{data.data.description}} </span>
                        </template>
                        <DxSummary :calculate-custom-summary="setSummaries">
                        <DxTotalItem column="id" summary-type="count" :display-format="`${$t('record')}: {0}`" show-in-column="id"/>
                            <DxGroupItem
                                :show-in-group-footer="true"
                                name="amount_local"
                                summary-type="custom"
                                show-in-column="amount_local"
                                display-format="{0}"
                            /> 
                            <DxTotalItem name="amount_local"
                                summary-type="custom"
                                show-in-column="amount_local"
                            />
                        </DxSummary>
                            <DxStateStoring
                                :enabled="true"
                                type="custom"
                                :storage-key="this.storageKey"
                                :ref="dataGrid" 
                                :saving-timeout="1000"
                                :custom-load="LoadDXState"
                            />
                    </DxDataGrid>
                </div>                  
            </div>
            <div class="card-footer" v-if="transactionDetailList.length == 0">
                <h5> {{ $t('no_results_found') }}.</h5> 
            </div>
        </div>
    </div>  
  </div>  
</template>

<script>
import axios from 'axios' 
import moment from 'moment';

import { DxDataGrid, DxFilterRow, DxHeaderFilter, DxGroupPanel, DxExport, DxPaging, DxPager, DxColumn, DxSearchPanel, DxSummary, DxTotalItem, DxStateStoring } from 'devextreme-vue/data-grid';
 
export default {
    name: "ExpenseTransactionList",
    components:{
        DxDataGrid, DxFilterRow, DxHeaderFilter, DxGroupPanel, DxExport, DxPaging, DxPager, DxColumn, DxSearchPanel, DxSummary, DxTotalItem, DxStateStoring
    },
    data() {
        return {
            storageKey: 'dx_' + this.$options.name,
            searchbar: '',
            isListProgressing: false,
            page_size: 10,
            page: 1,
            form: {
                first_date: moment().subtract((parseInt(this.$getUser().list_date_range)), 'days'),
                last_date: moment(),
            },
            transactionsList: [],
            pageSize: 10,
            pageIndex: 0,
            isViewDetail: false,
            transactionDetailList: [],
            transactionDetailData: {}
        };
    },
    computed: { 
        searchableList() {
            return this.transactionsList.filter(p => { 
                return p.docket_number.toLowerCase().indexOf(this.searchbar.toLowerCase()) != -1 || 
                    p.docket_type_name.toLowerCase().indexOf(this.searchbar.toLowerCase()) != -1
            }).slice((this.page - 1) * this.page_size, this.page * this.page_size);
        },
        previewDate(){
            return (value)=>{
            if (value) {
                return moment(new Date(value)).format('DD.MM.YYYY')
                }
            }
        },
        showPageSizeSelector() {
            return this.transactionsList.length > this.pageSize;
        },
        pageSizes() {
            let arr = [];
            let x = 1;
            let loop = (this.transactionsList.length / this.pageSize);
            for (let i = 1; i <= loop && i <= 5; i++) {
                arr.push(this.pageSize * x);
                x++;
            }
            if(loop > 5) arr.push(100);
            if(loop > 1) arr.push('all');
            return arr;
        },
        setColumnTemplateForLocal(){
            return (value)=>{
                const captionValue = value.column.caption.replace(this.$t('local'), ' ');
                return this.localCurrency == null ? this.$t(captionValue) : this.localCurrency + '<br>' + this.$t(captionValue);         
            }
        },
    },
    methods: {
        getData(isAuto) {
            if(isAuto && this.$getUser().is_allow_list_all_data) return;
            this.transactionsList = [];
            this.isViewDetail = false;
            this.transactionDetailList = [];
            this.transactionDetailData = {};
            this.$Progress.start();  
            this.isListProgressing = true;
            this.form.first_date = (this.form.first_date == null || this.form.first_date == '') ? moment() : this.form.first_date;
            this.form.last_date = ( this.form.last_date == null || this.form.last_date == '') ? moment () : this.form.last_date;
            const params = { 
                session_id: this.$getUser().session_id,
                docket_type: 8,
                first_date: this.form.first_date,
                last_date: this.form.last_date,
            };
            params.first_date = moment(params.first_date).format('YYYY-MM-DD[T]HH:mm:ss');
            params.last_date = moment(params.last_date).format('YYYY-MM-DD[T]HH:mm:ss'); 
            axios.post('api/Transaction/GetDockets', params, {'Content-Type': 'application/json'})
            .then((response) => {
                if(response.data.error == null || response.data.error == 'undefined' || response.data.error.length > 0){  
                    this.transactionsList = response.data; 
                    this.page = 1;
                    this.$Progress.finish();
                setTimeout(() => {
                    this.isListProgressing = false;
                }, 500);
                } 
                this.$Progress.finish(); 
                setTimeout(() => {
                    this.isListProgressing = false;
                }, 500);
            })
            .catch(() => {
                this.$Progress.finish();
                setTimeout(() => {
                    this.isListProgressing = false;
                }, 500);
            });  
        },
        updateDocket(id){ 
            this.$setSessionStorage('record_id', id);
            this.$parent.$refs.closeTransactionListModal.click();
            if (this.$route.name == 'ExpenseTransactionUpdate') {
                this.$router.go(0);
            } else {
                this.$router.push({ name: 'ExpenseTransactionUpdate' });
            }
        }, 
        setCriteriasToDefault() {   
            this.form = {
                first_date: moment().subtract((parseInt(this.$getUser().list_date_range)), 'days'),
                last_date: moment(),
            };
            this.transactionsList = [];
            this.getData();
        },
        onOpenDetail(item) {
            this.isViewDetail = true;
            this.transactionDetailData = item;
            const parameters = {
                session_id: this.$getUser().session_id,
                docket_header_id: item.id
            };  
            axios.post('/api/Transaction/GetDocketItems', parameters, {'Content-Type': 'application/json'})
            .then((response) => {
                if(response.data.error == null || response.data.error == 'undefined' || response.data.error == ''){
                    this.transactionDetailList = response.data;
                }
            })
            .catch((error) => {
                console.error(error);
            });
        },
        setSummaries(options){
            if(options.name == "amount_local"){
                if(options.summaryProcess === 'start'){
                    options.totalValue = 0;
                }
                else if(options.summaryProcess === 'calculate'){ 
                    var amount_local = parseFloat(options.value.amount_local.replaceAll(',', ''));
                    (options.totalValue += amount_local); 
                }
                else if(options.summaryProcess === 'finalize'){
                    options.totalValue = Intl.NumberFormat('en-US', { minimumFractionDigits: 2 }).format(options.totalValue);
                }
            } 
        },
        onCustomizeColumn(e){
            if(e){
                if(!e._isUpdated){
                    if(e.length > 0){ 
                        e._isUpdated = true;
                    }
                    e.forEach((column) => {   
                        if(column.dataField == 'amount_local'){ 
                            column.caption = this.$t('local_amount');
                            column.headerCellTemplate = 'headerLocalTemplate';
                        }
                    });  
                } 
            } 
        },
        getRowNumber(data) {
            return data.rowIndex + 1;
        },
        onBackStep() {
            this.isViewDetail = false;
            this.transactionDetailList = [];
            this.transactionDetailData = {};
        },
        /** DX STATE OPERATIONS **/  
        LoadDXState() {
            return JSON.parse(sessionStorage.getItem(this.storageKey));
        }, 
    }
}; 
</script>